import { Text } from '@msc-b2c/shared-components';
import { CardInfoProps } from '@msc-b2c/interfaces/types';
import styles from './cardinfo.module.scss';

export function CardInfo({ label, items, allowWrap = false }: CardInfoProps) {
  return (
    <div className={styles['cmp-cardinfo']}>
      <Text
        text={label}
        styleOption={`${styles['cmp-cardinfo__title']} body-default bold`}
        visible={true}
      />
      <div
        className={`${styles['cmp-cardinfo__content']} ${
          allowWrap ? styles['cmp-cardinfo__content--allow-wrap'] : ''
        }`.trim()}
      >
        {items.map((item) => (
          <Text
            key={item}
            text={item}
            styleOption={`${styles['cmp-cardinfo__text']} body-default`}
            visible={true}
          />
        ))}
      </div>
    </div>
  );
}
